export default "__VITE_ASSET__BrQCCmz8__"